import React from 'react';

const TextInfo = ({
  className = '',
  title = '',
  desc = '',
  childDesc = '',
}) => {
  return (
    <div className={`w-fit flex flex-col gap-1 ${className}`}>
      <p className={`text-xs text-[#667085] font-normal`}>{title}</p>
      <div className={`text-sm text-[#101828] font-medium`}>{desc}</div>
      <div className={`text-xs text-blue-500 font-normal underline`}>
        {childDesc}
      </div>
    </div>
  );
};

export default TextInfo;
